// Mood index → name mapping (used for palette mood tags)
// "Random" and "Similar" are omitted — they are generative, not descriptive moods.
// The integer index is what gets stored in Firebase (e.g. "2-7-14").

export const MOODS = [
  'Greenish',  // 0
  'Yellowish', // 1
  'Reddish',   // 2
  'Blueish',   // 3
  'Purplish',  // 4
  'Warm',      // 5
  'Pastel',    // 6
  'Vivid',     // 7
  'Summer',    // 8
  'Spring',    // 9
  'Autumn',    // 10
  'Winter',    // 11
  'Moody',     // 12
  'Neutral',   // 13
  'Retro',     // 14
  'Vintage',   // 15
  'Neon',      // 16
  'Day',       // 17
  'Night',     // 18
  'Dark',      // 19
  'Soft',      // 20
  'Skin',      // 21
  'Earth',     // 22
  'Cottage',   // 23
];

export const MAX_MOODS_PER_PALETTE = 5;

/** Parse a stored moods string ("2-7-14") into an array of mood names */
export function parseMoods(moodsString) {
  if (!moodsString || typeof moodsString !== 'string') return [];
  return moodsString
    .split('-')
    .map(s => parseInt(s, 10))
    .filter(n => !isNaN(n) && n >= 0 && n < MOODS.length)
    .map(n => MOODS[n]);
}

/** Serialize an array of mood names into a storable string ("2-7-14") */
export function serializeMoods(moodNames) {
  return moodNames
    .map(name => MOODS.indexOf(name))
    .filter(n => n !== -1)
    .join('-');
}
